import { useMemo } from "react";

let ticket = 1;

export function useUniqueId() {
  let id = useMemo(() => ticket++, []);

  return id;
}
